/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { RESERVAS_DETALLES_CLEAR, RESERVAS_DETALLES_SET } from './types'

import { ReservaDetalle } from '@/common/interfaces/reservasDetalle'

export const setReservasDetalles = (reservasDetalles: ReservaDetalle[]) => ({
  type: RESERVAS_DETALLES_SET,
  payload: reservasDetalles,
})

export const reservasDetallesClear = () => ({
  type: RESERVAS_DETALLES_CLEAR,
})
